import React from "react"

import { AppCrudTable } from "@components"
import { userSettingSitesData } from "../../../@signals"
import { actionsColumn, colorColumn, nameColumn } from "./columns"
import { isTourDemoActive } from "@signals/app"

export default function UserSettingsColorSitesTable() {
	if (isTourDemoActive.value && !userSettingSitesData.value?.length) return null
	return <AppCrudTable
		title="Site Colors"
		data={userSettingSitesData.value}
		columns={[
			nameColumn(),
			colorColumn(),
			actionsColumn()
		]}
	/>
}